import { Card, Row, Col, Divider, Flex, Typography } from "antd";
import { ReactElement } from "react";

const { Text } = Typography;

export default function FormSection({
  dividerStart,
  dividerEnd,
  title,
  columns,
  description,
  custom,
  children,
  extraContent,
  withoutCard,
  icon,
}: {
  dividerStart?: boolean;
  dividerEnd?: boolean;
  title?: string;
  icon?: string | ReactElement;
  custom?: boolean;
  description?: string;
  extraContent?: ReactElement;
  withoutCard?: boolean;
  children?: ReactElement;
  columns?: number[];
}) {
  return (
    <>
      {dividerStart ? (
        <Divider style={{ margin: "24px 0", opacity: 0.5 }} />
      ) : null}
      <Row
        gutter={[24, 24]}
        style={{ paddingTop: 12, paddingBottom: 12 }}
        align="top"
      >
        <Col lg={{ span: columns?.[0] ?? 8 }} xs={{ span: 24 }}>
          <Flex vertical gap={6}>
            <Flex align="center" gap={10}>
              {icon && (
                <span
                  style={{
                    fontSize: 20,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {icon}
                </span>
              )}
              <div
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1f2937",
                }}
              >
                {title ?? null}
              </div>
            </Flex>
            <Text
              type="secondary"
              style={{
                fontSize: 13,
                color: "#6b7280",
                marginLeft: icon ? 30 : 0,
              }}
            >
              {description ?? null}
            </Text>
          </Flex>
        </Col>
        <Col
          lg={{ span: columns?.[1] ?? (custom ? 12 : 10) }}
          xs={{ span: 24 }}
        >
          {withoutCard ? (
            children
          ) : (
            <Card
              style={{
                borderRadius: 12,
                border: "1px solid #e5e7eb",
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)",
              }}
              bodyStyle={{ padding: "16px" }}
            >
              {children}
            </Card>
          )}
        </Col>
        {columns?.[2] ? (
          <Col lg={{ span: columns?.[2] ?? 0 }} xs={{ span: 24 }}>
            {extraContent}
          </Col>
        ) : null}
      </Row>
      {dividerEnd ? (
        <Divider style={{ margin: "24px 0", opacity: 0.5 }} />
      ) : null}
    </>
  );
}
